module.exports = __webpack_public_path__ + "img/2.83f0a446.png";